import { render, staticRenderFns } from "./ProgramsPreview.vue?vue&type=template&id=f30a5c8a"
import script from "./ProgramsPreview.vue?vue&type=script&lang=js"
export * from "./ProgramsPreview.vue?vue&type=script&lang=js"
import style0 from "./ProgramsPreview.vue?vue&type=style&index=0&id=f30a5c8a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports